
import { useState } from "react";
import { validateGuess, validateWord, validateDuplicateGuess } from "../GuessValidation";
import { ValidatedGuess } from "@/lib/types/GameTypes";
import { toast } from "sonner";

export const useGuessValidator = (currentWord: string) => {
  const [isValidating, setIsValidating] = useState(false);
  const [invalidGuessType, setInvalidGuessType] = useState<"duplicate" | "invalid" | null>(null);

  const validateUserGuess = async (
    currentGuess: string,
    guesses: ValidatedGuess[]
  ): Promise<ValidatedGuess | null> => {
    if (!currentWord || currentGuess.length !== currentWord.length) {
      return null;
    }

    setIsValidating(true);
    setInvalidGuessType(null);

    try {
      // Check for duplicate guess
      if (validateDuplicateGuess(currentGuess, guesses)) {
        setInvalidGuessType("duplicate");
        return null;
      }

      // Validate word exists in dictionary
      const isValidWord = await validateWord(currentGuess);
      if (!isValidWord) {
        setInvalidGuessType("invalid");
        return null;
      }

      // Validate guess against target word
      return validateGuess(currentGuess.toLowerCase(), currentWord.toLowerCase());
    } catch (error) {
      console.error('Error validating guess:', error);
      toast.error("Error validating your guess. Please try again.");
      return null;
    } finally {
      setIsValidating(false);
    }
  };

  return {
    isValidating,
    setIsValidating,
    invalidGuessType,
    setInvalidGuessType,
    validateUserGuess
  };
};
